// extracted by mini-css-extract-plugin
module.exports = {"alignmentTool":"alignment_alignmentTool__zr45u"};